<ad-select-button [options]="options" [(ngModel)]="value" (onChange)="change($event);" (onOptionClick)="optionClick($event);"></ad-select-button>
